import { Link } from "react-router-dom";

function Residence({ residence }) {
  const imageUrl = "https://res.cloudinary.com/ddtmsdlip/";
  const {
    id,
    name,
    picture,
    university,
    location,
    number_of_rooms,
  } = residence;

  const image = imageUrl + picture;

  return (
    <div className="rounded-md m-4 bg-red-600 text-blue-950">
      <h2 className="text-xl text-white text-center font-bold bg-blue-950 md:hidden">
        {name}
      </h2>
      <div className="p-4 flex flex-col md:flex-row md:h-full">
        <div className="p-4">
          <img
            src={image}
            alt={name}
            className="rounded-lg w-full md:w-40 h-40"
          />
        </div>
        <div className="hidden md:block p-4 flex-grow">
          <h2 className="text-xl font-bold mt-2">{name}</h2>
          <p className="font-bold">{number_of_rooms} Rooms Available</p>
          <p>Located in {location}</p>
          <p>{university}</p>
        </div>
        <div className="p-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div className="md:hidden">
            <p className="font-bold">{number_of_rooms} Rooms Available</p>
            <p>Located in {location}</p>
            <p>{university}</p>
          </div>
          <div className="md:flex justify-center items-center">
            <Link
              to={`/residencies/${id}`}
              className="bg-blue-950 text-white m-2 p-2 rounded-lg"
            >
              View More Details
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Residence;
